









import { Prop, Vue } from 'vue-property-decorator';

export default class Palette extends Vue {
  @Prop({ type: String, default: '' }) readonly variant!: string;

  get variantClass() {
    const { variant } = this;

    return variant && `v-button--${variant}`;
  }
}
